import json from "../../json/generalSettings/disableConfigTransfer.json";
export default async () => JSON.parse(JSON.stringify(await json));
